export enum EngagementsTab {
  engagements = "engagements",
  leads = "leads",
  activity = "activity"
}

export type DateRange = 1000 | 30 | 7 | 1

export interface TabRangeState {
  [key: string]: DateRange
}
